import styled from 'styled-components';

export default styled.div`
	padding: var(--spacing-medium) var(--spacing-x-large);
`;
